





























import { Component, Prop, Watch } from "vue-property-decorator";
import InputControl from "@/components/Controls/InputControl.vue";
import ReportModel from "@/model/Report";
import ModelFactory from "@/model/ModelFactory";
import BaseForm from "@/components/Base/Form/BaseForm.vue";
import ReportApi from "@/api/Report";

import { required } from "vuelidate/lib/validators";

@Component({
  name: "OrganizationLink",
  components: {
    InputControl
  },
  validations: {
    report: {
      organizationReportUrl: { required }
    }
  }
})
export default class OrganizationLink extends BaseForm {
  @Prop()
  public value!: ReportModel;

  @Prop()
  public disabled!: boolean;

  public report: ReportModel = ModelFactory.create("ReportModel");
  public formName = "report";
  public formUrl = ReportApi.getOrganizationReportLinkUrl();

  @Watch("value")
  setReport(report: ReportModel) {
    this.report = report;
  }

  touch(validator: any) {
    validator?.$touch();
  }
}
